import React from 'react';
import styled from '@emotion/styled';
import Script from 'next/script';
import { NextSeo } from 'next-seo';

import HelpLayout from 'layouts/Help/HelpLayout';
import staticPage from 'lib/next/staticPage';

const Article = styled.article`
  width: 100% !important;
  margin: 0 auto;
`;

const CookiePolicy = () => (
  <HelpLayout title="Cookie Policy">
    <NextSeo title="Cookie Policy" />
    <Article>
      <div name="termly-embed" data-id="c91ccbcb-7258-4a74-8711-3a38b7d39b23" data-type="iframe"></div>
      <Script
        id="termly-privacy"
        dangerouslySetInnerHTML={{
          __html: `(function(d, s, id) {var js, tjs = d.getElementsByTagName(s)[0];if (d.getElementById(id)) return;js = d.createElement(s); js.id = id;js.src = "https://app.termly.io/embed-policy.min.js";tjs.parentNode.insertBefore(js, tjs);}(document, 'script', 'termly-jssdk'));`,
        }}
      />
    </Article>
  </HelpLayout>
);

export default staticPage()(React.memo(CookiePolicy));
